import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { StytchB2BProvider } from '@stytch/react/b2b'
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b'
import '@/styles/app.css'
import AppLayout from '@/layouts/AppLayout'

const publicToken =
  document.querySelector<HTMLMetaElement>('meta[name="stytch-public-token"]')?.content || ''

const stytch = new StytchB2BUIClient(publicToken)

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx', { eager: true }) as Record<string, { default: any }>
    const mod = pages[`../pages/${name}.tsx`]
    if (!mod) throw new Error(`Page not found: ${name}`)
    const component = mod.default
    if (!component.layout) {
      component.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
    }
    return component
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <StytchB2BProvider stytch={stytch}>
        <App {...props} />
      </StytchB2BProvider>
    )
  },
})
